
import './App.css';
import Buttons from './components/Buttons';

function App() {
  return (
    <div className="App">
    <Buttons />
    </div>
  );
}

export default App;
